'use strict';

var AppState = require('app_state');
var Consts = require('consts');
var Misc = require('utils/misc');

var StatsValueView = Marionette.ItemView.extend({
    template: require('components/devices/templates/tools/stats/stats_value'),
    events: {
        'click .js-remove': 'doDelete',
        'click .js-stats-tile-edit': 'doEdit',
        'change .js-aggregation': 'changeAggregation',
    },

    ui: {
        ddlAggregation: 'select.js-aggregation',
    },

    onRender: function () {
        Misc.initSelectPicker();
    },

    onShow: function () {
        Misc.initSelectPicker();
    },

    serializeData: function () {
        var data = Marionette.ItemView.prototype.serializeData.apply(this, []);

        var value = (data.result && data.result[data.aggregation.toLowerCase()]) || 0;
        var formatted = Misc.formatValueUnit(value, data.value, AppState.uniqueColumns());
        data.deviceUnit = formatted.unit;
        data.deviceValue = formatted.value;
        data.deviceCount = data.result && data.result.count;
        data.aggregations = Consts.Aggregation;
        return data;
    },

    doDelete: function (e) {
        e.preventDefault();
        e.stopPropagation();
        this.options.controller.deleteValue(this.options.data, this.model.get('idx'));
        this.options.updateCallback();
    },

    doEdit: function (e) {
        var self = this;
        e.preventDefault();
        e.stopPropagation();
        if (!this.options.canEdit) return;
        this.options.controller.addEditValue({
            data: this.options.data,
            cb: function () {
                self.options.updateCallback();
            },
            idx: this.model.get('idx'),
        });
    },

    changeAggregation: function (e) {
        e.preventDefault();
        e.stopPropagation();
        var newAggregation = this.ui.ddlAggregation.val();
        this.options.data.series[this.model.get('idx')].aggregation = newAggregation;
        this.render();
        if (this.options.updateCallback) this.options.updateCallback(true);
    },
});

module.exports = StatsValueView;
